import { Heart, Lock } from "lucide-react";
import { useFavorites } from "@/lib/favorites";
import { useLang } from "@/context/LanguageContext";

// Heart toggle. Visible to everyone; free users get the Plus/Premium toast on click.
export function FavoriteButton({ recipeId, className = "", size = "md" }) {
  const { t } = useLang();
  const { isFavorite, toggle, paid, busy } = useFavorites();
  const on = isFavorite(recipeId);
  const dim = size === "sm" ? "h-8 w-8" : "h-9 w-9";
  const icon = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  return (
    <button type="button" data-testid={`favorite-btn-${recipeId}`} aria-pressed={on} disabled={busy}
      title={on ? t("remove_favorite") : t("add_favorite")}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(recipeId); }}
      className={`relative grid place-items-center ${dim} rounded-full bg-background/90 backdrop-blur transition-transform duration-200 hover:scale-110 active:scale-95 ${className}`}>
      <Heart className={`${icon} transition-colors ${on ? "fill-primary text-primary" : "text-chenia-taupe"}`} />
      {!paid && <Lock className="absolute -bottom-0.5 -right-0.5 h-3 w-3 text-muted-foreground bg-background rounded-full p-[1px]" />}
    </button>
  );
}
